export default "/_next/static/images/ed59a2b02568a514cbf2f6f831658702.jpg";